module.exports = __webpack_public_path__ + "img/forgot-password-sent.3c53b550.png";